<template>
  <ul class="tabs flex ai-c fgap2">
    <li :class="['flex ai-c jc-c', activeTab == 1 ? 'active' : '']" @click="$emit('tabClick', 1)">
      <span class="text-md text-bold"> Dados Gerais </span>
    </li>
    <li :class="['flex ai-c jc-c', activeTab == 2 ? 'active' : '']" @click="$emit('tabClick', 2)">
      <span class="text-md text-bold">Logística</span>
      <span class="tag logistica ml-1">{{ process.containers.length }}</span>
    </li>
    <li :class="['flex ai-c jc-c', activeTab == 4 ? 'active' : '']" @click="$emit('tabClick', 4)">
      <span class="text-md text-bold">Documentos</span>
      <div class="flex ai-c">
        <div class="tooltip-file-new">
          <span class="tooltip-file-new__trigger ml-1">
              <span class="tag documentos">{{ docsTotalCount }}</span>
              <span class="content">Total de Arquivos</span>
        </span>
        </div>

        <div class="tooltip-file-new">
          <span class="tooltip-file-new__trigger ml-1">
            <span class="tag documentos-novos">{{ newDocsCount }}</span>
            <span class="content">Novos Arquivos</span>
          </span>
        </div>
      </div>
    </li>
    <li :class="['flex ai-c jc-c', activeTab == 5 ? 'active' : '']" @click="$emit('tabClick', 5)">
      <span class="text-md text-bold">Histórico</span>
      <span class="tag importacao ml-1">{{ process.history.length }}</span>
    </li>
    <!-- <li v-if="process.customer.id === 100"
        :class="['flex ai-c jc-c', activeTab == 6 ? 'active' : '']" @click="$emit('tabClick', 6)">
      <span>Integração</span>
    </li> -->
  </ul>
</template>

<script>

export default {
  name: 'ModalProcessTabList',
  props: {
    process: {
      type: Object,
      default: () => {
      },
    },
    activeTab: {
      type: Number,
      default: 1,
    },
    docs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    docsTotalCount() {
      return Array.isArray(this.docs) ? this.docs.length : 0;
    },
    newDocsCount() {
      if (!Array.isArray(this.docs)) return 0;
      return this.docs.filter((doc) => doc.new === true && !doc.currentUserHasDownloaded).length;
    },
  },
};
</script>

<style scoped>
.modal-tabs .tabs {
  position: relative;
  margin-bottom: -1px;
  overflow: visible;
}

.modal-tabs .tabs li {
  flex: 1 1 auto;
  padding: 0.75rem;
  overflow: visible;
  border-top-left-radius: var(--medium-border-radius);
  border-top-right-radius: var(--medium-border-radius);
  border-left: var(--small-border-width) solid transparent;
  border-right: var(--small-border-width) solid transparent;
  border-top: var(--small-border-width) solid transparent;
  cursor: pointer;
  height: 50px;
}

.modal-tabs .tabs li.active {
  background-color: var(--white-color);
  border-left: var(--input-border);
  border-right: var(--input-border);
  border-top: var(--input-border);
}

.tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: var(--round-border-radius);
  color: var(--white-color);
}

.tag.logistica {
  background-color: var(--accent-color);
}

.tag.importacao {
  background-color: var(--primary-color);
}

.tag.documentos {
  background-color: var(--light-text-color);
}

.tag.documentos-novos {
  background-color: var(--danger-color);
}

/* Tooltip puro em CSS */
.tooltip-file-new {
  display: inline-flex;
  align-items: center;
  cursor: help;
}

/* Trigger tem o mesmo tamanho da tag = centro do tooltip fica no centro da tag */
.tooltip-file-new__trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Tooltip aparece abaixo para não ser cortado pelo overflow do modal */
.tooltip-file-new .content {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 50%;
  transform: translateX(-50%) translateY(-2px);
  padding: 0.35rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--white-color);
  background-color: var(--dark-text-color, #333);
  border-radius: var(--small-border-radius, 4px);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Perninha (seta) centralizada no documentos-novos */
.tooltip-file-new .content::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -4px;
  border-width: 0 4px 4px 4px;
  border-style: solid;
  border-color: transparent transparent var(--dark-text-color, #333) transparent;
}

.tooltip-file-new:hover .content {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

</style>
